import { registerLocaleData } from '@angular/common';

import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeEsMX from '@angular/common/locales/es-MX';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import localeFrCA from '@angular/common/locales/fr-CA';
import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import localeTr from '@angular/common/locales/tr';
import localeKo from '@angular/common/locales/ko';
import localeJa from '@angular/common/locales/ja';
import localeNl from '@angular/common/locales/nl';
import localeZhHant from '@angular/common/locales/zh-Hant';

export function registerAllLocales(): void {
  registerLocaleData(localeEn);
  registerLocaleData(localeEs);
  registerLocaleData(localeEsMX);
  registerLocaleData(localeDe);
  registerLocaleData(localeFr);
  registerLocaleData(localeFrCA);
  registerLocaleData(localeIt);
  registerLocaleData(localePt);
  registerLocaleData(localePt, 'pt-BR');
  registerLocaleData(localeTr);
  registerLocaleData(localeKo);
  registerLocaleData(localeJa);
  registerLocaleData(localeNl);
  registerLocaleData(localeZhHant, 'zh-TW');
}
